// extracted by mini-css-extract-plugin
module.exports = {"textareaWrapper":"Textarea_textareaWrapper__OFwYu","textarea":"Textarea_textarea__32-Uf"};